import React, { Component } from "react";
import { connect } from "react-redux";
import { changeSwModeAction, changeEditerModeAction } from "../../redux/app/actions";
import { regEditerAction } from "../../redux/editer/actions";
import { changeRegionAction, changeCoordAction } from "../../redux/modelArea/actions";
import { openSwAction } from "../../redux/ui/actions";
import Select from "../common/Select";
import Sw from "../common/Sw";

const mapStateToProps = (state) => {
    return {
        region: state.modelAreaReducer.region,
        coord: state.modelAreaReducer.coord,
        paramRegion: state.paramReducer.region,
        boringDs: state.boringReducer.dataset,
    };
};
class Main extends Component {
    constructor(props) {
        super(props);
        //地域オプション
        this.regionOpt = [{ val: "0", text: "全表示" }];
        for (let key in this.props.paramRegion) {
            this.regionOpt.push({ val: key, text: key + " : " + this.props.paramRegion[key].name });
        }

        this.changeRegion = this.changeRegion.bind(this);
        this.closeSw = this.closeSw.bind(this);
        this.props.dispatch(changeEditerModeAction(1));

        //ボーリングエディタを閉じる
        //if (window.getBoringID() !== null) {
        //    let answer = window.confirm('ボーリングエディタを登録しますか。');
        //    this.props.dispatch(regEditerAction(answer));
        //}

        this.isStart = false; //描画を開始している場合true
        this.showRegion(this.props.region, true); //2023.04.14 学習領域押下時強制的に全表示となりユーザーの設定した視点が変わるためコメントアウト
        window.setDrawingFlag(true);
    }

    /*
     * 地域を地図上に表示
     * @since hara 2021-03-23
     */
    showRegion(region, init) {
        if (region === "0") {
            //全表示の場合
            const coords = [];
            for (let key in this.props.paramRegion) {
                coords.push(this.props.paramRegion[key].range);
            }
            if (!init) {
                window.showRegion(coords);
            }
            window.endModelArea(false);
            this.isStart = false;
        } else {
            const paramRegion = this.props.paramRegion[region];
            console.log("paramRegion");
            console.log(paramRegion);
            if (!init) {
                window.showRegion([paramRegion.range], paramRegion.zoom);
            }
            if (!this.isStart) {
                window.showRegion([paramRegion.range], paramRegion.zoom, false);
                window.startModelArea(false);
                this.isStart = true;
            }
        }
    }

    /*
     * 地域を地図上にすべて表示
     * @since ando 2023-08-08
     */
    showAllRegion(region, init) {
        if (region === "0") {
            //全表示の場合
            const coords = [];
            for (let key in this.props.paramRegion) {
                coords.push(this.props.paramRegion[key].range);
            }
            if (init) {
                window.showRegion(coords);
            }
        }
    }

    /*
     * 地域変更
     * @since hara 2021-03-23
     */

    async changeRegion(e) {
        const origin = window.location.origin;
        const search = window.location.search;
        const value = e.target.value;
        this.showRegion(value, false);
        this.props.dispatch(changeRegionAction(value));
        let hyperParamID = value;
        console.log(value);
        //選択したハイパーパラメータのIDをDBに登録
        /*
        await fetch(`${origin}/api/user/0/hyperparam/${hyperParamID}/${search}`,
            {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then(res => res.json())


            .catch(err => console.log(err));
            */

        if (window.existModelArea()) window.removeModelArea();
        //地域レンジ内のボーリングを格納
        window.registerAreaBoring(this.props);
    }

    /*
     * サブウィンドウを閉じる
     * @since hara 2020-09-09
     */
    closeSw() {
        if (window.existModelArea()) {
            this.props.dispatch(changeCoordAction(window.getModelAreaCoord()));
            this.props.dispatch(openSwAction(null));
            this.props.dispatch(changeSwModeAction(0));
            this.props.dispatch(changeEditerModeAction(0));

            window.endModelArea(false);
            window.setBoringID();
        } else {
            this.props.dispatch(openSwAction(null));
            this.props.dispatch(changeSwModeAction(0));
            this.props.dispatch(changeEditerModeAction(0));

            window.endModelArea(false);
            window.setBoringID();
        }
        window.setDrawingFlag(false);
    }

    render() {
        return (
            <Sw title="学習領域" focusName="area">
                <Select label="地域" options={this.regionOpt} value={this.props.region} class="selectM" blank={false} action={null} change={this.changeRegion} />
                <fieldset className="Unit l-mtS">
                    <legend>説明</legend>
                    <p>
                        クリック (1点目)：始点
                        <br />
                        クリック (2点目)：終点
                    </p>
                    <p className="l-mtS annot">
                        ※ 地域が全表示の場合、学習領域は
                        <br />
                        作成できません。
                    </p>
                </fieldset>
                <label className="l-mtM">選択ボーリング数：</label>
                <input className="textSSA" id="BoringNum" type="text" disabled="disabled" value={window.getSelBoringNum()} />
                <div className="l-right l-mtM">
                    <button className="cBtn" onClick={this.closeSw}>
                        閉じる
                    </button>
                </div>
            </Sw>
        );
    }
}

export default connect(mapStateToProps)(Main);
